import { css } from '@emotion/react';
import { ReactNode } from 'react';

export const Toggle = ({
	onChange,
	onBlur,
	name,
	value,
	children,
	marginBottom0,
}: {
	children?: ReactNode;
	marginBottom0?: boolean;
}) => {
	return (
		<label
			css={css`
				display: flex;
				align-items: center;
				font-size: 14px;
				line-height: 20px;
				font-weight: 500;

				&:hover {
					cursor: pointer;
				}

				${marginBottom0 &&
				css`
					margin-bottom: 0;
				`}
			`}
		>
			<div
				css={css`
					border-radius: 10px;
					background: #f1f1f4;
					width: 36px;
					height: 20px;
					position: relative;
					transition: all 0.2s ease-in-out;

					${!!value &&
					css`
						background: #46cb73;
						transition: all 0.2s ease-in-out;
					`}

					&:after {
						content: '';
						position: absolute;
						top: 2px;
						left: 2px;
						background: #a9abbc;
						width: 16px;
						height: 16px;
						border-radius: 16px;
						transition: all 0.2s ease-in-out;
						transform: translate(0, 0);

						${!!value &&
						css`
							background: #fff;
							transform: translate(16px, 0);
							transition: all 0.2s ease-in-out;
						`}
					}
				`}
			></div>
			<input
				css={css`
					display: none;
				`}
				type="checkbox"
				id={name}
				name={name}
				onChange={onChange}
				onBlur={onBlur}
				checked={value}
			/>
			{children && (
				<div
					css={css`
						margin-left: 12px;
					`}
				>
					{children}
				</div>
			)}
		</label>
	);
};
